<div class="app-body">
    <div class="row">
        <div class="col-xxl-12">
            <div class="card" style="margin-left: 1px;">
                <div class="card-body">
                    <div class="custom-tabs-container">
                        <ul class="nav nav-tabs justify-content-end" id="customTab5" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="tab-CompanyInfo" data-bs-toggle="tab" href="#CompanyInfo"
                                    role="tab" aria-controls="CompanyInfo" aria-selected="true">
                                    <span class="badge bg-info" style="font-size: 16px;">Thẩm định An toàn thực phẩm</span>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="customTabContent">
                            <div class="tab-pane fade show active" id="CompanyInfo" role="tabpanel">
                                <div class="row gx-4">
                                    <div class="col-lg-4 col-sm-12 col-12">
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <h1>Thẩm định An toàn thực phẩm</h1>
                                        </div>
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <label class="form-label">Bước 01:</label> <a class="link-primary"
                                                target="_blank" href="{{excelCompanyInfoURL}}" title="Tải về">Tải về</a>
                                            file
                                            excel mẫu
                                        </div>
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <label class="form-label">Bước 02:</label> Chọn file
                                        </div>
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <input class="form-control" type="file" #uploadCompanyInfo
                                                (change)="ChangeCompanyInfo($event.target.files)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                                        </div>
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <label class="form-label">Bước 03:</label> Chọn danh mục
                                        </div>
                                        <div class="col-lg-12 col-sm-12 col-12">
                                            <select class="form-select" name="UploadService.BaseParameter.ParentID"
                                                [(ngModel)]="UploadService.BaseParameter.ParentID">
                                                <option *ngFor="let item of DanhMucCompanyPhanLoaiService.List;"
                                                    [value]="item.ID">
                                                    {{item.Name}}</option>
                                            </select>
                                        </div>
                                        <br />
                                        <button [disabled]="!isCompanyInfo" class="btn btn-info"
                                            (click)="SubmitCompanyInfo()" style="width: 100%;">Upload</button>
                                    </div>
                                    <div class="col-lg-8 col-sm-12 col-12">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="UploadService.IsShowLoading"></app-loading>